import React from "react";
import Header from "./Header";
import PqrsdConfig from "../pqrsd/config/PqrsdConfig";

export default function LayoutPqrsdConfig() {
  return (
    <>
      <Header />
      <PqrsdConfig />
    </>
  );
}
